import React, { Component } from "react";
import Header from "../components/Header";
import { Twitter, Hash, Globe, Bookmark } from "react-feather";
import moment from "moment";
import Footer from "../components/Footer";

export default class Roadster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      errormsg: "",
      roadsterdata: [],
      reverse: false,
    };
  }

  fetchData = () => {
    fetch("https://api.spacexdata.com/v3/roadster")
      .then((response) => {
        if (response.status !== 200) {
          if (response.status == 429) {
            this.setState({
              isLoading: true,
              errormsg:
                "We're currently experiencing high loads. Please try refreshing.",
            });
          } else {
            this.setState({
              isLoading: true,
              errormsg:
                "We couldn't fetch the data. Status code: " + response.status,
            });
          }
          return;
        }

        // Examine the text in the response
        response.json().then((data) => {
          this.setState({
            roadsterdata: data,
            isLoading: false,
            errormsg: "",
          });
        });
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      });
  };

  componentDidMount() {
    this.setState({ isLoading: true });
    this.fetchData();
  }

  render() {
    const { isLoading, roadsterdata, errormsg, reverse } = this.state;

    if (isLoading || errormsg) {
      return (
        <>
          <Header />
          <section class="hero is-black is-fullheight">
            <div class="hero-body">
              <div class="container has-text-centered">
                {errormsg ? (
                  <>
                    <h1 className="title is-5 has-text-white">
                      SpaceX Tracker
                    </h1>
                    <p>{errormsg}</p>
                    <br />
                    <button
                      onClick={() => {
                        window.location.reload();
                      }}
                      className="button is-dark"
                      style={{ marginBottom: "25px" }}
                    >
                      Try again
                    </button>
                    <br />
                    <a href="https://www.twitter.com/ingusjan" target="_blank">
                      <Twitter size={18} />
                    </a>
                  </>
                ) : (
                  <p style={{ opacity: "0.2" }}>Loading</p>
                )}
              </div>
            </div>
          </section>
        </>
      );
    }

    return (
      <div>
        <Header />

        <div className="has-text-centered">
          <h1
            className="title is-2 has-text-white"
            style={{ marginTop: "60px", zIndex: "5" }}
          >
            Tesla Roadster
          </h1>
          <p>
            {moment(roadsterdata.launch_date_utc).format("DD/MM/YYYY hh:mm:ss")}
          </p>
          <p className="help" style={{ opacity: "0.3" }}>
            {roadsterdata.launch_mass_kg} kg -{" "}
            {roadsterdata.earth_distance_km &&
              Math.round(roadsterdata.earth_distance_km)}{" "}
            km from Earth - {Math.round(roadsterdata.speed_kph)} km/h
          </p>

          <p
            className="help"
            style={{ width: "60%", margin: "0 auto", marginTop: "20px" }}
          >
            {roadsterdata.details}
          </p>
          <a
            className="help"
            target="_blank"
            style={{ marginTop: "20px" }}
            href={roadsterdata.wikipedia}
          >
            {roadsterdata.wikipedia}
          </a>
          <img src="roadster.jpg" width="700px" style={{ margin: "0 auto" }} />
        </div>

        <Footer />
      </div>
    );
  }
}
